<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">州市涉旅案件查处情况</div>
        <div class="branch">-0.3</div>
      </div>
      <div class="tip">
        <div class="con">大理州-大理市</div>
        <div class="con">一类地区</div>
      </div>
      <div class="date">2019-11-01 12:31:22</div>
    </div>
    <div class="pg-pd12">
      <!-- 扣分原因 -->
      <causeDeduction :causeContent="causeContent" />
      <!-- 扣分详情 -->
      <template v-if="subType=='A1'||subType=='A2'">
        <causeDetail :detailList="detailList" :title="detailTitle" />
      </template>

      <div v-if="subType=='A1'||subType=='A2'" class="complain" @click="toComplaintDetails">
        <span>查看投诉件详情</span>
      </div>
      <div class="main"> <!--v-if="subType=='A3'"-->
        <div class="title">投诉办结情况</div>
        <div class="content">
          <div style="height:250px;">
            <pieCharts :pieData="pieList" />
          </div>
          <div class="tongji">
            <div class="tj-item">
              <div class="name">已办结数量</div>
              <div class="num">{{compDoneInfo.doneInNum}}<span>起</span></div>
            </div>
            <div class="tj-item">
              <div class="name">未办结数量</div>
              <div class="num">{{compDoneInfo.doneOutNum}}<span>起</span></div>
            </div>
            <div class="tj-item">
              <div class="name">总数量</div>
              <div class="num">{{compDoneInfo.doneNum}}<span>起</span></div>
            </div>
          </div>
          <div class="ts-list" @click="navTo()">
            <span> 查看投诉件列表</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import Vue from 'vue';
    import causeDeduction from './components/causeDeduction';
    import causeDetail from './components/causeDetail';
    import pieCharts from '../../components/PieCharts';// 环形进度
    import api from '../../service/modules/appraise';

    // Vue.use(Picker);
    export default {
        components: {
            causeDeduction,
            causeDetail,
            pieCharts
        },

        data () {
            return {
                subType: 'A1',
                // 饼图
                pieList: [
                    { 'value': 90, 'name': '已办结数量' },
                    { 'value': 10, 'name': '总数量' }
                ],
                causeContent: '接到游客投诉未在5分钟内响应',
                detailTitle: '扣分详情',
                detailList: [{
                                 name: '投诉单号',
                                 value: '26834738423435'
                             },
                             {
                                 name: '发生地区',
                                 value: '昆明市安宁区'
                             },
                             {
                                 name: '响应时间',
                                 value: '45分钟'
                             },
                             {
                                 name: '处理时长',
                                 value: '25小时3分钟'
                             },
                             {
                                 name: '一次处理时长',
                                 value: '25小时3分钟'
                             },
                             {
                                 name: '二次处理时长',
                                 value: '0分钟'
                             }
                ],
                complainInfo: {},
                compDoneInfo: {}
            }
        },

        computed: {},

        watch: {},

        methods: {
            // 考核明细接口
            getSubAssessDetail () {
                api.getAssessDetailById({ id: '335C6B06-33CA-D7E4-B539-C35B6B9BA99E', complainId: '201907141721243498431', subType: 'A1' }).then(res => {
                    if (res.ret === 0) {
                        this.complainInfo = res.data.complainInfo// 扣分详情
                        this.compDoneInfo = res.data.compDoneInfo// 投诉办结详情
                        if (this.subType == 'A1') {
                            this.detailList = [{
                                                   name: '投诉单号',
                                                   value: this.complainInfo.complainId
                                               },
                                               {
                                                   name: '发生地区',
                                                   value: this.complainInfo.complainArea
                                               },
                                               {
                                                   name: '响应时间',
                                                   value: this.complainInfo.respTime
                                               }
                            ]
                        } else {
                            this.detailList = [{
                                                   name: '投诉单号',
                                                   value: this.complainInfo.complainId
                                               },
                                               {
                                                   name: '发生地区',
                                                   value: this.complainInfo.complainArea
                                               },
                                               {
                                                   name: '响应时间',
                                                   value: this.complainInfo.respTime
                                               },
                                               {
                                                   name: '处理时长',
                                                   value: this.complainInfo.doneTime
                                               },
                                               {
                                                   name: '一次处理时长',
                                                   value: this.complainInfo.firstTime
                                               },
                                               {
                                                   name: '二次处理时长',
                                                   value: this.complainInfo.secondTime
                                               }
                            ]
                        }
                        this.pieList = [
                            { 'value': this.compDoneInfo.doneInNum, 'name': '已办结数量' },
                            { 'value': this.compDoneInfo.doneOutNum, 'name': '未办结数量' },
                            { 'value': this.compDoneInfo.doneNum, 'name': '总数量' }
                        ]
                    } else {
                        this.$Message.error(res.data.msg)
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/complainList'
                })
            },
            toComplaintDetails () {
                this.$store.commit('complaint/setHandleWorkbench', false);
                this.$router.push({
                    path: this.compDoneInfo // 跳转到投诉件详情
                })
            }
        },

        mounted () {},

        created () {
            this.getSubAssessDetail()
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);

    .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }

    .head {
      width: 100%;
      background: #fff;
      padding: 24px 12px;
      margin-bottom: 24px;

      .title {
        height: 22px;
        line-height: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .text {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }

        .branch {
          height: 22px;
          font-size: 22px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: rgba(255, 77, 77, 1);
          line-height: 22px;
        }
      }

      .tip {
        margin-top: 12px;
        display: flex;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(54, 179, 116, 1);

        .con {
          border: 1Px solid rgba(54, 179, 116, 1);
          padding: 2px 4px;
          margin-right: 14px;
        }
      }

      .date {
        margin-top: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }
    }
    .complain{
      position: relative;
      line-height:46px;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      padding: 0 16px;
      margin-top: 24px;
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
    .complain::after{
      content: '';
      position: absolute;
      right: 16px;
      top: 16px;
      width: 12px;
      height: 12px;
      background: url(../../assets/image/t-right.png) no-repeat;
      background-size: 12px 12px;
    }
    .main{
      margin-top: 24px;
      padding-bottom: 30px;
      .title{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
      }
      .content{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-top: 12px;
        .tongji{
          display: flex;
          align-items: center;
          border-top: solid 1Px #EEEEEE;
          border-bottom: solid 1Px #EEEEEE;
          margin-top: 24px;
          .tj-item{
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;
            height: 72px;
            text-align: center;
            border-right: solid 1Px #EEEEEE;
            .name{
              font-size:12px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(51,51,51,1);
            }
            .num{
              font-size:20px;
              font-family:DIN-Bold,DIN;
              font-weight:bold;
              color:rgba(54,179,116,1);
              margin-top: 8px;
              span{
                font-size: 10px;
                padding-left: 4px;
              }
            }
          }
          .tj-item:last-child{
            border-right: 0;
          }
        }
        .ts-list{
          padding: 12px 0;
          text-align: center;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(155,155,155,1);
          line-height:17px;
          span{
            padding-right: 10px;
            background: url(../../assets/image/t-right.png) no-repeat;
            background-size: 8px 8px;
            background-position: right center;
          }
        }
      }
    }
  }
</style>
